module.exports = __webpack_public_path__ + "static/amira-8bea4d7f596bd21798f2d0879c456800.png";